/**
 * BuddyGroupCardholderSelect -- Lets user change primary cardholder for this rodeo.
 */
import { Button } from '@/components/ui/button';
import { Crown } from 'lucide-react';

interface Member {
  id: string;
  user_profile_id: string;
  display_name: string | null;
  is_primary: boolean;
}

interface BuddyGroupCardholderSelectProps {
  members: Member[];
  currentPrimaryId: string;
  onChangePrimary: (userProfileId: string) => void;
  isLoading?: boolean;
}

export function BuddyGroupCardholderSelect({
  members,
  currentPrimaryId,
  onChangePrimary,
  isLoading,
}: BuddyGroupCardholderSelectProps) {
  if (members.length <= 1) return null;

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-muted-foreground">Primary Cardholder</p>
      <div className="space-y-1">
        {members.map((m) => (
          <div key={m.user_profile_id} className="flex items-center justify-between p-2 rounded-md">
            <span className="text-sm flex items-center gap-1">
              {m.user_profile_id === currentPrimaryId && (
                <Crown className="h-3 w-3 text-amber-500" />
              )}
              {(m.display_name ?? 'Unknown')}
            </span>
            {m.user_profile_id !== currentPrimaryId && (
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => onChangePrimary(m.user_profile_id)}
                disabled={isLoading}
                className="text-xs"
              >
                Make Primary
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
